import { styled, Tooltip, tooltipClasses } from '@mui/material';
import React from 'react';

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: '16px',
    backgroundColor: theme.palette.common.white,
    color: 'rgba(57, 69, 83, 1)',
    fontsize: '14px',
    borderRadius: '8px',
    boxShadow: '0px 0px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
    fontSize: 11,
  },
}));
